
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic11Off as ObiHydraulic11OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-11-off.js';
 
 
 

 
 export const ObiHydraulic11Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-11-off',
   elementClass: ObiHydraulic11OffElement,
   events: {
     
   }
  });
 
 